import {
  defineFeatureFlag,
  readFlag,
  useBooleanFlag,
  usePosthogFlag,
} from '@heidi/runtime/feature-flags';

export const chenmedEngineV2Flag = defineFeatureFlag({
  key: 'release-ml-scribe-chenmed-engine-v2',
  defaultValue: false,
  description: 'ChenMed nudge engine v2',
});

export const useIsChenmedEngineV2Enabled = (): boolean =>
  useBooleanFlag(chenmedEngineV2Flag.key, chenmedEngineV2Flag.defaultValue);

export const patientDigitalTwinFlag = defineFeatureFlag({
  key: 'release-na-fde-patient-digital-twin',
  defaultValue: false,
  provider: 'posthog',
  description: 'Patient Digital Twin inspector',
});

export const PATIENT_DIGITAL_TWIN_FLAG_KEY = patientDigitalTwinFlag.key;

export const useIsPatientDigitalTwinEnabled = (): boolean =>
  usePosthogFlag(patientDigitalTwinFlag) ?? false;

export const inSessionNudgesChenmedFlag = defineFeatureFlag({
  key: 'release-ml-scribe-in-session-nudges-chenmed',
  defaultValue: false,
  description: 'ChenMed in-session protocol nudges',
});

export const useIsInSessionNudgesChenmedEnabled = (): boolean =>
  useBooleanFlag(inSessionNudgesChenmedFlag.key, inSessionNudgesChenmedFlag.defaultValue);

export const getIsInSessionNudgesChenmedEnabled = (): boolean =>
  readFlag(inSessionNudgesChenmedFlag.key, inSessionNudgesChenmedFlag.defaultValue);
